import { useState } from "react";
import { Columns2 } from "lucide-react";
import { Shell, PageHead, Section } from "./dc";

const SHOTS = [
  ["leads", "Leads (top)"], ["leads2", "Leads (list)"], ["exec", "Exec Dashboard (top)"], ["exec2", "Exec Dashboard (charts)"], ["goinghome", "Going Home Board"],
  ["booking-curve", "Day View & Booking Curve"], ["going-home", "Going Home / Belongings"], ["package-renewals", "Package Renewals"],
  ["requested", "Requested"], ["bath-list", "Bath List"], ["collars", "Collars"], ["rooms", "Rooms"], ["churn", "Churn"],
  ["occupancy", "Occupancy Trend"], ["private-play", "Private Play"], ["mobile", "Phone (390px)"],
];

const Pair = ({ k }) => (
  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 420px), 1fr))", gap: 16 }}>
    {["before", "after"].map((v) => (
      <figure key={v} style={{ margin: 0 }} data-testid={`dc-review-${v}-${k}`}>
        <figcaption className="label" style={{ marginBottom: 6 }}>{v === "before" ? "Before" : "After · V3"}</figcaption>
        <a href={`/design-review/${v}-${k}.jpg`} target="_blank" rel="noreferrer">
          <img src={`/design-review/${v}-${k}.jpg`} alt={`${v} ${k}`} style={{ width: "100%", borderRadius: 8, border: "1px solid var(--border)", display: "block", maxHeight: k === "mobile" ? 640 : undefined, objectFit: "contain", background: "var(--surface-raised)" }} />
        </a>
      </figure>
    ))}
  </div>
);

export default function ReviewPage() {
  const [k, setK] = useState(SHOTS[0][0]);
  return (
    <Shell title="" testid="dc-review">
      <PageHead title="Before & after · V3" sub="Real screens (Daily Ops, Leads, Exec Dashboard, Going Home) before and after applying V3. Click an image to open it full size." />
      <div className="tabs" style={{ marginBottom: 16, flexWrap: "wrap", borderRadius: 16 }} data-testid="dc-review-tabs">
        {SHOTS.map(([id, l]) => <button key={id} className={`tab ${k === id ? "active" : ""}`} onClick={() => setK(id)} data-testid={`dc-review-tab-${id}`}>{l}</button>)}
      </div>
      <Section title={SHOTS.find((s) => s[0] === k)[1]} sub="Left: current production look · Right: V3 soft blend" icon={Columns2}><Pair k={k} /></Section>
    </Shell>
  );
}
